"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _statefulRadiogroupContainer = _interopRequireDefault(require("./stateful-radiogroup-container.js"));

var _radiogroup = _interopRequireDefault(require("./radiogroup.js"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
} // Styled elements


var StatefulRadioGroup = function StatefulRadioGroup(props) {
  var children = props.children,
      restProps = _objectWithoutProperties(props, ["children"]);

  return _react.default.createElement(_statefulRadiogroupContainer.default, restProps, function (childrenProps) {
    return _react.default.createElement(_radiogroup.default, childrenProps, children);
  });
};

StatefulRadioGroup.displayName = 'StatefulRadioGroup';
var _default = StatefulRadioGroup;
exports.default = _default;